import React from "react";
import Modal from '../Modal'
import LoaderButton from "../../components/LoaderButton";
import { checkTranslation, imageAddress, translate } from "../../utils/useful";
import SidebarView from "../SidebarView";
import ButtonAnimated from "../buttons/ButtonAnimated";
import StagesManager from "../StagesManager";
import FormViewer from "../FormViewer";
import HttpServices from "../../utils/Http.services";
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import * as actions from '../../stores/actionsList';
import FixedView from "../FixedView";



class ConnectModals extends React.Component {
    state = {

        isLoadingRequest: {},
        connectionsRelationStatus: {},
        isLoadingHandle: {},
        // options: [
        //     { image: "/assets/images/coverphoto.jpg", title: "{{lang}}Family", limit: "{{lang}}Public", description: "{{lang}}There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form", applet1: "/images/icons/red.svg", applet2: "/images/icons/orange.svg", applet3: "/images/icons/blue.svg", applet4: "/images/icons/purple.svg" },
        //     { image: "/assets/images/coverphoto.jpg", title: "{{lang}}Friends", limit: "{{lang}}Private", description: "{{lang}}There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form", applet1: "/images/icons/red.svg", applet2: "/images/icons/orange.svg", applet3: "/images/icons/blue.svg", applet4: "/images/icons/purple.svg" },
        //     { image: "/assets/images/coverphoto.jpg", title: "{{lang}}Colleagues", limit: "{{lang}}Public", description: "{{lang}}There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form", applet1: "/images/icons/red.svg", applet2: "/images/icons/orange.svg", applet3: "/images/icons/blue.svg", applet4: "/images/icons/purple.svg" },
        //     { image: "/assets/images/coverphoto.jpg", title: "{{lang}}Work", limit: "{{lang}}Permission", description: "{{lang}}There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form", applet1: "/images/icons/red.svg", applet2: "/images/icons/orange.svg", applet3: "/images/icons/blue.svg", applet4: "/images/icons/purple.svg" },
        //     { image: "/assets/images/coverphoto.jpg", title: "{{lang}}Family", limit: "{{lang}}Public", description: "{{lang}}There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form", applet1: "/images/icons/red.svg", applet2: "/images/icons/orange.svg", applet3: "/images/icons/blue.svg", applet4: "/images/icons/purple.svg" },
        //     { image: "/assets/images/coverphoto.jpg", title: "{{lang}}Friends", limit: "{{lang}}Private", description: "{{lang}}There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form", applet1: "/images/icons/red.svg", applet2: "/images/icons/orange.svg", applet3: "/images/icons/blue.svg", applet4: "/images/icons/purple.svg" },
        //     { image: "/assets/images/coverphoto.jpg", title: "{{lang}}Colleagues", limit: "{{lang}}Public", description: "{{lang}}There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form", applet1: "/images/icons/red.svg", applet2: "/images/icons/orange.svg", applet3: "/images/icons/blue.svg", applet4: "/images/icons/purple.svg" },
        //     { image: "/assets/images/coverphoto.jpg", title: "{{lang}}Work", limit: "{{lang}}Permission", description: "{{lang}}There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form", applet1: "/images/icons/red.svg", applet2: "/images/icons/orange.svg", applet3: "/images/icons/blue.svg", applet4: "/images/icons/purple.svg" },
        // ],
    }

    componentDidMount() {

        this.init()
    }

    componentDidUpdate(prevProps) {

        if (prevProps.relation != this.props.relation) {
            this.init()
        }
    }


    init = () => {

        let relation = this.props.relation
        let connectionTypes = this.props.connectionTypes

        let connectionsRelationStatus = {}

        if (relation && Array.isArray(connectionTypes)) {

            let relationGroups = relation.groups
            let requests = relation.requests

            connectionTypes.forEach(connectionType => {

                if (Array.isArray(connectionType.groups)) {

                    let foundAll = true


                    connectionType.groups.forEach(connectionGroup => {
                        let found = false

                        relationGroups.forEach(relationGroup => {

                            if ((relationGroup?._id ?? relationGroup) == (connectionGroup?._id ?? connectionGroup)) {
                                found = true
                            }

                        });

                        if (!found) {
                            foundAll = false
                        }

                    });

                    if (foundAll && (relation.status == 'C' || relation.status == 'S')) {
                        connectionsRelationStatus[connectionType._id] = 'C'
                    }
                }

                if (connectionsRelationStatus[connectionType._id] != 'C') {
                    if (Array.isArray(requests)) {

                        requests.forEach(request => {
                            if (request.connectionType == connectionType._id && request.status == 'P') {
                                connectionsRelationStatus[connectionType._id] = 'R'
                            }
                        });

                    }
                }


            })

            this.setState({ connectionsRelationStatus })

        }

    }

    open = () => {
        this.modal.open()
        setTimeout(() => {
            this.setState({ revealFixed: true })
        }, 100);
    }

    connecionClicked = (item) => {

        // console.log(item)
        this.setState({ currentConnection: item }, () => {

            if (item.hasForm && item.form) {

                let fields = []
                item.form[0].pageContent[0].sectionContent.map((prop) => {
                    prop.rowContent.map((element) => {
                        fields.push(element)
                    })
                })

                this.setState({ headers: fields }, () => {
                    this.stagesManager.changeStage("form")
                })
            } else {

                this.postConnectionRequest()
            }
        })
    }


    postConnectionRequest = () => {

        let connection = this.state.currentConnection
        let form
        if (connection.hasForm && connection.form) {
            form = this.form.getForm()

            if (!form) {
                return
            }
        }

        let isLoadingRequest = this.state.isLoadingRequest


        if (!isLoadingRequest[connection._id]) {

            isLoadingRequest[connection._id] = true

            let body = {
                connection: connection._id,
                form,
                hub: this.props.hub?._id
            }

            // console.log("body", body)
            this.setState({ isLoadingRequest })


            HttpServices.request('postConnectionRequest', body, (fetchResult, fetchError, fetchStatus) => {

                isLoadingRequest[connection._id] = false

                this.setState({ isLoadingRequest })

                // console.log(fetchResult, fetchError)


                if (fetchError) {
                    this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.loadDataFailed', description: fetchError.message })
                    return
                }


                this.props.setRelation(fetchResult.relation)
                this.goToListPage()

                this.props.actions.addNotif({ type: 'success', title: '{{lang}}info.postedSuccesfully', description: '{{lang}}info.dataPostedSuccessfully' })




            })

        }

    }


    cancelRequest = (connectionType) => {


        let isLoadingRequest = this.state.isLoadingRequest

        // console.log("cancelRequest",isLoadingRequest)

        if (!isLoadingRequest[connectionType._id]) {

            isLoadingRequest[connectionType._id] = true
            this.setState({ isLoadingRequest })

            let body = {
                connectionType: connectionType._id,
                hub: this.props.hub?._id
            }

            HttpServices.request('cancelConnectionRequest', body, (fetchResult, fetchError, fetchStatus) => {

                isLoadingRequest[connectionType._id] = false

                this.setState({ isLoadingRequest })

                // console.log(fetchResult, fetchError)


                if (fetchError) {
                    this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.loadDataFailed', description: fetchError.message })
                    return
                }


                this.props.setRelation(fetchResult.info)
                this.props.actions.addNotif({ type: 'success', title: '{{lang}}info.postedSuccesfully', description: '{{lang}}info.dataPostedSuccessfully' })




            })
        }
    }


    handleInvitation = (item, accept) => {

        let isLoadingHandle = this.state.isLoadingHandle ?? {}

        if (!isLoadingHandle[item._id]) {
            isLoadingHandle[item._id] = accept ? '1' : '0'
            this.setState({ isLoadingHandle })
            // console.log("HERE!", item)
            let body = { notifRef: item._id, accept }

            // console.log(body)

            HttpServices.request('handleInvitationRequest', body, (fetchResult, fetchError) => {

                isLoadingHandle[item._id] = null
                this.setState({ isLoadingHandle })

                if (fetchError) {
                    this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.loadDataFailed', description: fetchError.message })
                    return
                }


                if (fetchResult.info) {
                    if (fetchResult.info.trashed == true) {

                        this.props.setRelation(null)

                    } else {
                        this.props.setRelation(fetchResult.info)
                    }
                }


                // let data = this.state.data
                // data.forEach(element => {
                //     if (item._id == element._id) {
                //         element.actionStatus = (accept ? 'A' : 'D')
                //     }
                // })

                // this.setState({ data })

            })


        }

    }


    openUnconnectModal = (item) => {

        this.setState({ currentConnection: item }, () => {

            this.unconnectModal.showModal()

        })
    }

    openUnconnectCompletelyModal = () => {

        this.unconnectCompletelyModal.showModal()
        this.plusFixedView.hideView()
    }



    confirmedUnconnect = () => {


        let connectionType = this.state.currentConnection

        let isLoadingRequest = this.state.isLoadingRequest

        if (!isLoadingRequest[connectionType._id]) {

            isLoadingRequest[connectionType._id] = true

            let body = {
                connectionType: connectionType._id,
                hub: this.props.hub?._id
            }

            // console.log("body", body)
            this.setState({ isLoadingRequest })


            HttpServices.request('postUnconnect', body, (fetchResult, fetchError, fetchStatus) => {

                isLoadingRequest[connectionType._id] = false

                this.setState({ isLoadingRequest })

                // console.log(fetchResult, fetchError)


                if (fetchError) {
                    this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.loadDataFailed', description: fetchError.message })
                    return
                }

                this.unconnectModal.hideModal()

                this.props.setRelation(fetchResult.info)
                this.props.actions.addNotif({ type: 'success', title: '{{lang}}info.postedSuccesfully', description: '{{lang}}info.dataPostedSuccessfully' })




            })

        }

    }


    confirmedUnconnectCompletely = () => {



        let isLoadingRequest = this.state.isLoadingRequest

        if (!isLoadingRequest['**Completely']) {

            isLoadingRequest['**Completely'] = true

            let body = {
                hub: this.props.hub?._id
            }

            this.setState({ isLoadingRequest })


            HttpServices.request('postUnconnectCompletely', body, (fetchResult, fetchError, fetchStatus) => {

                isLoadingRequest['**Completely'] = false

                this.setState({ isLoadingRequest })

                // console.log(fetchResult, fetchError)


                if (fetchError) {
                    this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.loadDataFailed', description: fetchError.message })
                    return
                }

                this.unconnectCompletelyModal.hideModal()

                this.props.setRelation(fetchResult.info)
                this.props.actions.addNotif({ type: 'success', title: '{{lang}}info.postedSuccesfully', description: '{{lang}}info.dataPostedSuccessfully' })




            })

        }

    }


    goToListPage = () => {
        this.stagesManager.changeStage('List')
        this.setState({ revealFixed: false }, () => {
            this.setState({ revealFixed: true })
        })
    }

    render() {
        let options = this.props.connectionTypes
        let invitations = this.props.relation?.invitations
        let relation = this.props.relation
        return (
            <>
                <Modal onHide={() => this.setState({ revealFixed: false })} width={this.props.width} ref={el => this.modal = el} hideOverlay={false} maxWidth={400} widthCondition={{ xs: "100%", sm: "100%", md: '50%', lg: "33.3%", xl: "25%" }}>

                    <StagesManager ref={(el) => this.stagesManager = el} fast={true}>

                        <div stage={0} stageName="List" className="w-100 br-10 pb-3 " style={{ backgroundColor: "white" }} >
                            <div className="d-flex  px-3 pt-2 pb-2 top-0 mb-2" style={{ borderRadius: '10px 10px 0px 0px', position: 'sticky', background: '#fff', borderBottom: '1px solid #eee' }}>
                                <div className="mrd-2 flexcc">
                                    <img className="br-30" src={imageAddress(this.props.hub?.image, 'hub', 'small')} height={26} width={26} alt="" />
                                </div>
                                <p className="font-size-18 text-bold py-1">{this.props.hub?.fullname} - {translate('Connection')}</p>
                            </div>
                            {/* {console.log("aa", relation)} */}
                            {relation != null && relation.trashed != true && (relation.status == 'C' || relation.status == 'S') && (
                                <div className="px-3 py-2">
                                    <div className="px-3 py-3 br-8 " style={{ background: 'linear-gradient( to right,  #764BA210,#667EEA10)' }}>

                                        <div className="flexcb w-100">
                                            <p className="text-bold text-semibig connected-text">{translate("You are connected this hub")}</p>

                                            <div className="flexcc">
                                                <button onClick={() => this.plusFixedView.showView()} ref={el => this.plusBut = el} className="br-30  flexcc mld-3" >
                                                    <img src="/assets/icons/useful/more (1).png" className="rorate-90" height={20} alt='' />
                                                </button>
                                            </div>
                                        </div>

                                        {this.state.revealFixed && (
                                            <FixedView width={this.props.width} zIndex={10} ref={el => this.plusFixedView = el} nodeRef={this.plusBut} xOffset={-7} bottomOffset={this.props.fullSize ? -7 : 0} topOffset={7} maxWidth={200} >
                                                <div className='bg-white br-10 py-2 px-2 shadow-3 sc-gray2 d-flex flex-column'>



                                                    <button className="w-100 p-0 text-start flexc mt-1 px-1 mb-2" onClick={() => this.openUnconnectCompletelyModal()}>
                                                        <img src='/assets/icons/useful/menu.png' height={15} alt='' />
                                                        <p className="text-smaller text-semibold px-1  ">{translate('Unconnect from all groups')}</p>
                                                    </button>

                                                    {/* <button className="w-100 p-0 text-start flexc mt-1 px-1 mb-2" onClick={() => this.props.toggleConfig()}>
                                                        <img src='/assets/icons/useful/edit.png' height={15} alt='' />
                                                        <p className="text-smaller text-semibold px-1  ">{translate('Block hub')}</p>

                                                    </button> */}

                                                </div>
                                            </FixedView>
                                        )}

                                        {Array.isArray(relation.groups) && relation.groups.length > 0 && (
                                            <div>
                                                <p className="text-smaller">{translate("You are already part of the following groups")}</p>
                                                <div className="flexc mt-2">
                                                    {relation.groups.map((group, k) => {
                                                        return (
                                                            <div className="mrd-2 br-20 px-2 py-1 text-smaller" key={group._id} style={{ backgroundColor: '#007aff15', color: '#007aff' }}>
                                                                <p>{group.name}</p>
                                                            </div>
                                                        )
                                                    })}
                                                </div>
                                            </div>
                                        )}


                                    </div>
                                </div>
                            )}

                            {Array.isArray(invitations) && invitations.length > 0 && (
                                <div className="w-100 px-3 mb-2">
                                    < div className="mb-2 br-8" style={{ backgroundColor: '#007aff15', border: '1px solid #eee' }}>
                                        {invitations.map((invitation, j) => {
                                            return (
                                                <div className="px-3 py-3" key={invitation._id}>
                                                    <p className="text-semibold">{translate("You have an invitation to connect to this hub")}</p>
                                                    {Array.isArray(invitation.groups) && invitation.groups.length > 0 && (
                                                        <div>
                                                            <p className="text-smaller">{translate("If you accept the invitation you will be joined to the following groups")}</p>
                                                            <div className="flexc mt-2">
                                                                {invitation.groups.map((group, k) => {
                                                                    return (
                                                                        <div className="mrd-2 br-20 px-2 py-1 text-smaller" key={group._id} style={{ backgroundColor: '#007aff15', color: '#007aff' }}>
                                                                            <p>{group.name}</p>
                                                                        </div>
                                                                    )
                                                                })}
                                                            </div>
                                                        </div>
                                                    )}


                                                    <div className="flexce mt-2">
                                                        <div className="flexc mrd-2">
                                                            <ButtonAnimated
                                                                onClick={() => this.handleInvitation(invitation, false)}
                                                                title={translate('Decline')}
                                                                isLoading={this.state?.isLoadingHandle[invitation._id] == '0'}
                                                                textColor={'#777'}
                                                                bg={'#e0e0e0'}
                                                                width={'100%'}
                                                            />
                                                        </div>
                                                        <div className="flexc">
                                                            <ButtonAnimated
                                                                iconwidth='24px'
                                                                onClick={() => this.handleInvitation(invitation, true)}
                                                                title={translate('Accept')}
                                                                icon='/assets/icons/check-white.svg'
                                                                textColor={'#fff'}
                                                                isLoading={this.state?.isLoadingHandle[invitation._id] == '1'}
                                                                bg={this.props.background ?? ' linear-gradient(90deg, #3062D4, #3062D4)'}
                                                                width={'100%'}
                                                            />
                                                        </div>

                                                    </div>

                                                </div>
                                            )
                                        })}
                                    </div>
                                </div>
                            )}

                            <div>
                                {options?.map((item, index) => {
                                    return (
                                        <div className="d-flex px-3 pb-2 pt-2 connect-selection " style={{ borderBottom: (index < options.length - 1) ? "1px solid #f6f6f6" : '' }}>
                                            {/* <div>
                                        <img className="br-50" style={{ objectFit: "cover", width: "40px", height: "40px" }} src={item.image} />
                                    </div> */}
                                            <div className="w-100">
                                                <div className="flexcb">
                                                    <div className="flexc">
                                                        <div className="flexc">
                                                            <img className="mrd-2" src="/assets/icons/useful/link (4).png" height={18} alt="" />
                                                            <p className="font-size-16 text-semibold">{checkTranslation(item.name)}</p>
                                                        </div>
                                                        <p className="font-size-12 br-20  px-2 py-1 mx-1 text-semibold" style={{ color: "#007aff", background: "#007aff20" }}>{checkTranslation(item.type)}</p>

                                                    </div>

                                                    <div className="flexc">

                                                        {/* <div className="flexcc">
                                                        <img width={20} src={'/assets/icons/angle-right.svg'} />
                                                    </div> */}

                                                        {this.state.connectionsRelationStatus[item._id] != null ? (
                                                            <div className="flexcc ">

                                                                {this.state.connectionsRelationStatus[item._id] == 'C' && (
                                                                    <ButtonAnimated
                                                                        iconwidth='24px'
                                                                        onClick={() => { this.openUnconnectModal(item) }}
                                                                        title={translate("Connected")}
                                                                        // icon='/assets/icons/arrow-right-white.svg'
                                                                        textColor={'#777'}
                                                                        isLoading={this.state.isLoadingRequest[item._id]}
                                                                        // invert={this.props.colors?.iconInvert}
                                                                        bg={'#e0e0e0'}
                                                                    />
                                                                )}

                                                                {this.state.connectionsRelationStatus[item._id] == 'R' && (

                                                                    <ButtonAnimated
                                                                        iconwidth='24px'
                                                                        onClick={() => { this.cancelRequest(item) }}
                                                                        title={translate("Requested")}
                                                                        textColor={'#777'}
                                                                        invert={true}
                                                                        isLoading={this.state.isLoadingRequest[item._id]}
                                                                        bg={'#e0e0e0'}
                                                                    />

                                                                )}

                                                            </div>
                                                        ) : (
                                                            <div className="flexcc ">
                                                                {item.type == 'Public' && (
                                                                    <ButtonAnimated
                                                                        iconwidth='24px'
                                                                        onClick={() => this.connecionClicked(item)}
                                                                        title={translate("Connect Now")}
                                                                        icon='/assets/icons/arrow-right-white.svg'
                                                                        textColor={'#fff'}
                                                                        isLoading={this.state.isLoadingRequest[item._id]}
                                                                        // invert={this.props.colors?.iconInvert}
                                                                        bg={'linear-gradient(90deg, rgb(88, 86, 214), rgb(124, 122, 255))'}
                                                                    />
                                                                )}

                                                                {item.type == 'Private' && (
                                                                    <ButtonAnimated
                                                                        iconwidth='24px'
                                                                        onClick={() => this.connecionClicked(item)}
                                                                        title={translate("Send request")}
                                                                        icon='/assets/icons/arrow-right-white.svg'
                                                                        textColor={'#fff'}
                                                                        isLoading={this.state.isLoadingRequest[item._id]}
                                                                        // invert={this.props.colors?.iconInvert}
                                                                        bg={'linear-gradient(90deg, rgb(88, 86, 214), rgb(124, 122, 255))'}
                                                                    />
                                                                )}

                                                                {item.type == 'Permission' && (
                                                                    <ButtonAnimated
                                                                        iconwidth='24px'
                                                                        onClick={() => this.connecionClicked(item)}
                                                                        title={translate("Connected")}
                                                                        icon='/assets/icons/arrow-right-white.svg'
                                                                        textColor={'#000'}
                                                                        isLoading={this.state.isLoadingRequest[item._id]}
                                                                        invert={true}
                                                                        bg={'linear-gradient(90deg, #ddd, #ddd)'}
                                                                    />
                                                                )}
                                                            </div>
                                                        )}
                                                    </div>
                                                </div>

                                                {Array.isArray(item.groups) && item.groups.filter((a) => !a.hidden).length > 0 && (
                                                    <div className="flexc mt-1">
                                                        <p className=" text-semibold text-smaller">{translate("Groups")}:</p>

                                                        {item.groups.map((group, index) => {
                                                            if (!group.hidden) {
                                                                return (
                                                                    <div className="br-20  mld-2" style={{}}>
                                                                        <p className="text-smaller text-semibold">{group.name}{index < item.groups.length - 1 ? ',' : ''}</p>
                                                                    </div>
                                                                )
                                                            }
                                                        })}

                                                    </div>
                                                )}

                                                {item.description && item.description.trim() != '' && (
                                                    <div className="mt-1 mb-2">
                                                        <p className="text-smaller">{checkTranslation(item.description)}</p>
                                                    </div>
                                                )}
                                            </div>
                                        </div>
                                    );
                                })}
                            </div>
                            {/* <div className="px-5 pt-4 d-flex justify-content-end">
                        <LoaderButton
                            // onClick={() => this.userCheck()}
                            // isLoading={this.state.isLoading}
                            text={translate("Submit")}
                            backgroundImage='linear-gradient(45deg, #30A1B8 0%, #5598DE 40%, #8E81F4  70%, #F45495  90%, #EE4358  100%)'
                            shadow="0px 0px 14px -7px #007aff;"
                            icon={'/assets/icons/angle-right-white2.svg'}
                            className={'button-interactive-1'}
                            language={this.props.language}
                        />
                    </div> */}
                        </div>


                        <div stage={1} stageName="form" className="w-100 br-10 pb-3 " style={{ backgroundColor: "white" }}>

                            <div className="px-2 pt-2 pb-2 top-0 flexc py-1" style={{ zIndex: 1, borderRadius: '10px 10px 0px 0px', position: 'sticky', background: '#fff', borderBottom: '1px solid #eee' }}>
                                <button className="flexcc" onClick={() => this.goToListPage()} >
                                    <img className="invert mrd-1 rotate-180" src="/assets/icons/arrow-right-white.svg" height={24} alt="" />
                                </button>
                                <p className="font-size-18 text-semibold ">{translate('Fill the form')}</p>
                            </div>
                            <div className="w-100 pt-3">
                                <FormViewer ref={el => this.form = el} initData={this.state.currentAction} headers={this.state?.headers} formClass="bordered-form" inputClass={'bordered-input'} params={this.props.params} />

                                <div className="mt-0 mb-3 px-3 flexce">
                                    <ButtonAnimated
                                        iconwidth='24px'
                                        onClick={() => { this.postConnectionRequest() }}
                                        title={translate("Submit")}
                                        icon='/assets/icons/arrow-right-white.svg'
                                        textColor={'#fff'}
                                        isLoading={this.state.isLoadingRequest[this.state.currentConnection?._id]}
                                        // invert={this.props.colors?.iconInvert}
                                        bg={'linear-gradient(90deg, rgb(88, 86, 214), rgb(124, 122, 255))'}
                                    />
                                </div>
                            </div>

                        </div>

                    </StagesManager>
                </Modal >



                <Modal ref={el => this.unconnectModal = el} maxWidth={450}>
                    <div className="w-100  " style={{ backgroundColor: '#fff', borderRadius: 8 }}>
                        <div className="p-4">
                            <p className="text-normal weight-600 pb-3" style={{}}>{checkTranslation(this.props.description) ?? translate('Are you sure you want to unconnect?')}</p>
                            <p className="text-small weight-500 main-c7" style={{}}>{translate('If you unconnect you will not be part of the groups of this connection type and you will loose your access to the applets and frames of these groups.')}</p>
                            <div className="flexc w-100 pt-4" style={{ justifyContent: 'flex-end' }}>
                                <div className="flexc mrd-2">
                                    <ButtonAnimated
                                        iconwidth='24px'
                                        onClick={() => { this.unconnectModal.hideModal() }}
                                        title={translate('Cancel')}
                                        textColor={'#a3a2b0'}
                                        bg={'#eee'}
                                    />
                                </div>
                                <div className="flexc mld-2">
                                    <ButtonAnimated
                                        iconwidth='24px'
                                        isLoading={this.state.isLoadingRequest[this.state.currentConnection?._id]}
                                        onClick={() => { this.confirmedUnconnect() }}
                                        title={translate('Unconnect')}
                                        icon='/assets/icons/angle-right-white2.svg'
                                        textColor={'#fff'}
                                        bg={'#c83418'}
                                    />
                                </div>
                            </div>


                        </div>
                    </div>
                </Modal>



                <Modal ref={el => this.unconnectCompletelyModal = el} maxWidth={450}>
                    <div className="w-100  " style={{ backgroundColor: '#fff', borderRadius: 8 }}>
                        <div className="p-4">
                            <p className="text-normal weight-600 pb-3" style={{}}>{checkTranslation(this.props.description) ?? translate('Are you sure you want to unconnect completely?')}</p>
                            <p className="text-small weight-500 main-c7" style={{}}>{translate('If you unconnect you will be unconnected from all groups and your access to all private applets and frames will be terminated.')}</p>
                            <div className="flexc w-100 pt-4" style={{ justifyContent: 'flex-end' }}>
                                <div className="flexc mrd-2">
                                    <ButtonAnimated
                                        iconwidth='24px'
                                        onClick={() => { this.unconnectCompletelyModal.hideModal() }}
                                        title={translate('Cancel')}
                                        textColor={'#a3a2b0'}
                                        bg={'#eee'}
                                    />
                                </div>
                                <div className="flexc mld-2">
                                    <ButtonAnimated
                                        iconwidth='24px'
                                        isLoading={this.state.isLoadingRequest['**Completely']}
                                        onClick={() => { this.confirmedUnconnectCompletely() }}
                                        title={translate('Unconnect completely')}
                                        icon='/assets/icons/angle-right-white2.svg'
                                        textColor={'#fff'}
                                        bg={'#c83418'}
                                    />
                                </div>
                            </div>


                        </div>
                    </div>
                </Modal>
            </>
        );

    }
}


// export default ConnectModals;

const mapStateToProps = state => ({ settings: state.settings, user: state.user, connections: state.connections })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps,
    null,
    { forwardRef: true }
)(ConnectModals);